;
var ccuidStorerNameSpace = ccuidStorerNameSpace || {};
ccuidStorerNameSpace.ccuidQueryStringStorer = function () {
    const checkPage = function () {
        var pathName = window.location.pathname.toLowerCase();
        if (pathName == "/salary-planner" || pathName == "/salary-checker/salary-calculator") {
            return true;
        }
        else {
            return false;
        }
    }

    const fetchCCUID = function () {
        const params = new URLSearchParams(window.location.search.toLowerCase());
        if (params.has("ccuid")) {
            return params.get("ccuid")
        }
    }

    const storeCCUID = function (ccuid) {
        sessionStorage.setItem("ccuid", ccuid);
    }

    const isRightPage = checkPage();
    if (isRightPage) {
        const ccuid = fetchCCUID();
        if (ccuid != null && ccuid != "") {
            storeCCUID(ccuid);
        }
    }

    const setCCUIDToEvar = function (linkName) {
        var s = s_gi(analLib.getSiteId());
        s.linkTrackVars = s.linkTrackVars.indexOf("eVar165") != -1 ? s.linkTrackVars : s.linkTrackVars + ",eVar165";
        s.eVar165 = sessionStorage.getItem("ccuid");
        s.tl(this, 'o', linkName);
    }

    const fireRegisterOnSubmitEventCCUID = function () {
        const loadCCUIDTracking = function () {
            if (window.location.pathname.toLowerCase() != "/account/register") {
                return false;
            }
            setCCUIDToEvar("submit button click");
        }

        var ccuid = sessionStorage.getItem("ccuid");
        if (document.getElementById("frmMain") !== null && ccuid !== undefined && ccuid !== null) {
            document.getElementById("frmMain").addEventListener("submit", loadCCUIDTracking);
        }
    }
    
    const fireOnDOMContentLoadEventCCUID = function () {
        const loadCCUIDTracking = function () {
            setCCUIDToEvar("on dom content load");
        }

        var ccuid = sessionStorage.getItem("ccuid");
        if (ccuid !== undefined && ccuid !== null) {
            document.addEventListener("DOMContentLoaded", loadCCUIDTracking);
        }
    }

    fireRegisterOnSubmitEventCCUID();
    fireOnDOMContentLoadEventCCUID();
}();